import { useTheme } from 'hephaestus/web';
import { useMemo } from 'react';

export const useEntityMenuColors = () => {
  const theme = useTheme();

  return useMemo(() => {
    const { palette } = theme;
    return [
      { color: palette.supportOne60, colorsInner: palette.supportOne10 },
      { color: palette.supportTwo60, colorsInner: palette.supportTwo10 },
      { color: palette.supportThree60, colorsInner: palette.supportThree10 },
      { color: palette.supportFour60, colorsInner: palette.supportFour10 },
      { color: palette.supportFive60, colorsInner: palette.supportFive10 },
      { color: palette.supportSix60, colorsInner: palette.supportSix10 },
    ];
  }, [theme]);
};
